export const CACHE_KEY_EMPLOYEE_CREATE_REQUEST = 'employee-create-request';
export const CACHE_KEY_MANAGER_CREATE_REQUEST = 'manager-create-request';
